var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 18,
    height: 18,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71875 8.13195C2.71875 5.14232 5.14232 2.71875 8.13195 2.71875C11.1216 2.71875 13.5451 5.14232 13.5451 8.13195C13.5451 9.59117 12.9678 10.9155 12.029 11.8891C12.0031 11.9089 11.9782 11.9307 11.9546 11.9543C11.9309 11.978 11.9091 12.0029 11.8893 12.0288C10.9157 12.9677 9.59127 13.5451 8.13195 13.5451C5.14232 13.5451 2.71875 11.1216 2.71875 8.13195ZM12.4614 13.5219C11.2766 14.4748 9.77085 15.0451 8.13195 15.0451C4.31389 15.0451 1.21875 11.95 1.21875 8.13195C1.21875 4.31389 4.31389 1.21875 8.13195 1.21875C11.95 1.21875 15.0451 4.31389 15.0451 8.13195C15.0451 9.77073 14.4749 11.2763 13.5221 12.4612L16.3665 15.3056C16.6594 15.5985 16.6594 16.0734 16.3665 16.3662C16.0736 16.6591 15.5987 16.6591 15.3058 16.3662L12.4614 13.5219Z",
    fill: "#8C99B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.263479ba3491ed7477a734f799a0cbfa.svg";
export { ForwardRef as ReactComponent };